import type { GridRowSelectionModel } from '@cognite/cogs-lab';
import { DeleteIcon, ReportListIcon } from '@cognite/cogs.js-v10';
import { LOCIZE_NAMESPACES, useTranslation } from '@infield/features/i18n';
import { ActionMenu } from '@infield/features/ui';
import type { FC } from 'react';

interface SchedulesToolbarProps {
  selectedRows: GridRowSelectionModel;
  onClose: () => void;
  onDeleteClick: () => void;
  onCreateClick: () => void;
}

const SchedulesToolbar: FC<SchedulesToolbarProps> = ({
  selectedRows,
  onClose,
  onDeleteClick,
  onCreateClick,
}) => {
  const { t } = useTranslation(LOCIZE_NAMESPACES.checklist);
  return (
    <ActionMenu
      visible
      subTitle={t('SCHEDULES_TOOLBAR_TITLE', {
        defaultValue: `${selectedRows.length} selected`,
        schedulesLength: selectedRows.length,
      })}
      actions={[
        {
          key: 'Delete',
          name: t('SCHEDULES_TOOLBAR_BUTTON_DELETE', 'Delete'),
          type: 'ghost-destructive',
          icon: <DeleteIcon />,
        },
        {
          key: 'MoveToReady',
          name: t('SCHEDULES_TOOLBAR_BUTTON_MOVE_TO_READY', 'Move to ready'),
          type: 'primary',
          inverted: true,
          icon: <ReportListIcon />,
        },
      ]}
      onActionClick={(key) => {
        switch (key) {
          case 'Delete':
            onDeleteClick();
            break;
          case 'MoveToReady':
            onCreateClick();
            break;
        }
      }}
      onClose={onClose}
    />
  );
};

export default SchedulesToolbar;
